import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => (
  <Link to="/" data-testid="brand-logo" className={`group inline-flex items-center gap-2 sm:gap-3 ${className}`} dir="ltr">
    <span className={`font-latin text-[17px] tracking-[0.3em] sm:text-[26px] sm:tracking-[0.42em] ${light ? "text-ivory" : "text-ink"}`}>QAMAR</span>
    <span className="relative h-6 w-px bg-gold" />
    <span className={`text-[22px] leading-none sm:text-[30px] ${light ? "text-ivory" : "text-ink"}`} style={{ fontFamily: "Amiri, serif" }}>
      قمر
    </span>
  </Link>
);
